import styled from "styled-components";
import theme from "~/styles/theme";

export const UploadDropZone = styled.div`
  padding: 30px;
  border: 2px dashed;
  border-radius: 16px;
    ${(props) =>
      props.error
        ? theme.palette.feedback.error.key
        : theme.palette.neutral.primary.key};
  background-color: ${theme.palette.neutral.primary.light};
  border-radius: 8px;
  text-align: center;

  p {
    font-family: ${theme.typography.fontFamilyRegular};
  }

  p,
  strong {
    color: ${theme.palette.neutral.primary.key};
  }

  button {
    background-color: ${theme.palette.brand.primary.key};
    border-color: ${theme.palette.brand.primary.key};
    width: 100%;

    &:hover {
      span {
        color: ${theme.palette.neutral.primary.light};
      }
    }
  }
`;

export const FileName = styled.div`
  background-color: ${theme.palette.neutral.primary.light};
  padding: 16px 0;
  border-radius: 8px;

  p {
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 24px;
  }

  strong {
    margin: 0 8px 8px 0px;
  }
`;
